import styled from 'styled-components';
import typography from '../../../../theme/typography';
const StyledColorFragment = styled.section`
  h4 {
    ${typography.Subtitle1}
  }

  p {
    ${typography.Body3}
    margin-bottom: 15px;
  }
`;

export default StyledColorFragment;
